export default (zipcode: string | undefined | null) => {
  if (!zipcode) {
    return '';
  }

  return zipcode.slice(0, 5);
};
